import { render, staticRenderFns } from "./CourseAdjustmentApprovalProcess.vue?vue&type=template&id=27255fcc"
import script from "./CourseAdjustmentApprovalProcess.vue?vue&type=script&lang=js"
export * from "./CourseAdjustmentApprovalProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports